// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3habI","colMaxWidth":"Table_colMaxWidth__3iVqT"};